import { usePreviewPanelsContext } from '../preview-panel-context';
import type { Panel } from '../types';

export const useCurrentPreviewPanel = ():
	| (Panel & { setWidth: (width: number) => void; width: number })
	| null => {
	const context = usePreviewPanelsContext();

	if (context?.state.panel == null) {
		return null;
	}

	return {
		...context.state.panel,
		width: context.width,
		setWidth: context.setPanelWidth,
	};
};
